import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions';
import ScoreRecord from './scoreRecord';
import _ from 'lodash';
import { formValueSelector, reset } from 'redux-form/immutable'
import {_isDepartmentUser} from "../../helpers/functions";
import {toJS} from "../hocs/toJs";

const selector = formValueSelector('scoreTypeForm');

const parseCities = (citiesIM) => {
  return citiesIM.valueSeq().toArray().map(store => ({
    city: store.get('city'),
  }))
};

const parseStoreSuggestions = (storesIM) => {
  return storesIM.valueSeq().toArray().map(store => ({
    id: store.get('id'),
    name: store.get('name'),
    new: store.get('new'),
    newComing: store.get('newComing'),
    old: store.get('old'),
    dwId: store.get('dwId'),
    enterSoftCode: store.get('enterSoftCode'),
    openDate: store.get('openDate'),
    city: store.get('city'),
  }))
};


const parseScoreRecords = (scoreRecords) => {

  return scoreRecords.valueSeq().toArray().map(scoreRecord => ({
    id: scoreRecord.get('id'),
    createdDate: scoreRecord.get('createdDate'),
    personId: scoreRecord.get('personId'),
    scores: scoreRecord.get('scores') && scoreRecord.get('scores').valueSeq().toArray().map(score => ({
      id: score.get('id'),
      criteriaId: score.get('criteriaId'),
      storeId: score.get('storeId'),
      scoreValue: score.get('scoreValue'),
    }))
  }));
};


const parseRoles = (roles) => {
  const parsedNews = [];
  roles.valueSeq().toArray().forEach(role => (
    parsedNews.push({
      id: role.get('id'),
      name: role.get('name'),
    })));
  return parsedNews;
};

const parseCriteria = (criteriaIM) => {
  return criteriaIM.valueSeq().toArray().map(criterion => ({
    id: criterion.get('id'),
    name: criterion.get('name')
  }))
};

const parseStores = (storesIM) => {
  return storesIM.valueSeq().toArray().map(store => ({
    id: store.get('id'),
    name: store.get('name'),
    new: store.get('new'),
    newComing: store.get('newComing'),
    old: store.get('old'),
    dwId: store.get('dwId'),
    enterSoftCode: store.get('enterSoftCode'),
    openDate: store.get('openDate'),
  }))
};

const parseStore = (storeIM) => {
  return {
    id: storeIM.get('id'),
    name: storeIM.get('name'),
    new: storeIM.get('new'),
    newComing: storeIM.get('newComing'),
    old: storeIM.get('old'),
    dwId: storeIM.get('dwId'),
    enterSoftCode: storeIM.get('enterSoftCode'),
    openDate: storeIM.get('openDate'),
  }
};

const parseCriterionFromFormTable = (criterionIM) => {
  return {
    id: criterionIM.get('id'),
    name: criterionIM.get('name'),
  }
};

const parseScoreRecord = (criteria, stores) => {
  return {
    stores: stores.map(store => ({
      id: store.id,
      name: store.name,
      dwId: store.dwId,
      enterSoftCode: store.enterSoftCode,
      new: store.new,
      newComing: store.newComing,
      old: store.old,
      openDate: store.openDate,
      criteria: criteria.map(criterion => ({
        id: criterion.id,
        name: criterion.name,
        scoreValue: '',
      }))
    }))
  };
};

const parseFormScoreRecordTable = (formIM) => {
  return formIM.get('stores').valueSeq().toArray().map(store => ({
    id: store.get('id'),
    criteria: store.get('criteria').valueSeq().toArray().map(criterion => ({
      id: criterion.get('id'),
      scoreValue: criterion.get('scoreValue')
    }))
  }))
};


class ScoreRecordHOC extends Component {

  componentDidMount(){
    if(this.props.match.params.id){
      this.props.getScoreRecordById({id:this.props.match.params.id})
    }
    if(_isDepartmentUser(this.props.personRoles)){
      this.props.getScoreRecords({
        filter: {include: 'scores'},
        where: {departmentId: this.props.loggedInPersonDepartmentId}
      })
    }
    this.props.getCities();
  }

  fetchCitiesSuggestions = (value) => {
    const suggestions = this.props.cities.filter(item => {
      return item.city.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()
        .includes(value.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase())
    });
    this.props.changeStoresState({
      key: 'citiesSuggestions',
      value: suggestions
    })
  };

  fetchStoresSuggestions = (property, limit) => (value) => {
    let scoreTypeFilter = {};
    if(this.props.scoreTypeFormValue === 'newStores'){
      scoreTypeFilter = {new: true}
    }

    if(this.props.scoreTypeFormValue === 'newComingStores'){
      scoreTypeFilter = {newComing: true}
    }

    if(this.props.scoreTypeFormValue === 'oldStores'){
      scoreTypeFilter = {old: true}
    }

    this.props.getStoresSuggestions({
      filter: {
        where: {and: [{[property]: {like: `%25${value}%25`}}, scoreTypeFilter ]},
        limit: limit
      }
    })
  };

  submitStoreType = (formIM) => {
    const scoreType = formIM.get('scoreType');
    const storesWhereAndFilter = [];
    if(formIM.get('enterSoftCode')){
      storesWhereAndFilter.push({enterSoftCode: {like: `%25${formIM.get('enterSoftCode')}%25`}});
    }
    if(formIM.get('code')){
      storesWhereAndFilter.push({dwId: {like: `%25${formIM.get('code')}%25`}})
    }
    if(formIM.get('name')){
      storesWhereAndFilter.push({name : {like: `%25${formIM.get('name')}%25`}})
    }
    if(formIM.get('city')){
      storesWhereAndFilter.push({city : {like: `%25${formIM.get('city')}%25`}})
    }
    const criteriaWhereAndFilter =  [
      {or: [{deleted: false}, {deleted: null}]},
      {departmentId: this.props.loggedInPersonDepartmentId}
    ];
    if(scoreType === 'newStores'){
      storesWhereAndFilter.push({new: true});
      criteriaWhereAndFilter.push({weightNew: {gt: 0}});
    }
    if(scoreType === 'newComingStores'){
      storesWhereAndFilter.push({newComing: true});
      criteriaWhereAndFilter.push({weightNewComing: {gt: 0}});
    }
    if(scoreType === 'oldStores'){
      storesWhereAndFilter.push({old: true});
      criteriaWhereAndFilter.push({weightOld: {gt: 0}});
    }

    this.props.getStores({
      filter: {where: {and: storesWhereAndFilter}}
    });

    this.props.getCriteria({
      filter: {where: {and: criteriaWhereAndFilter}}
    });
  };

  scoreRecordSubmit = (formIM) => {
    const form = parseFormScoreRecordTable(formIM);

    const scores = [];
    _.forEach(form, store => {
      _.forEach(store.criteria, criterion => {
        scores.push({
          storeId: store.id,
          criteriaId: criterion.id,
          scoreValue: criterion.scoreValue?criterion.scoreValue:null,
          createdDate: new Date()
        })
      })
    });
    this.props.createScoreRecord({
      sendBody:{
        scoreRecord: {
          createdDate: new Date(),
          personId: this.props.loggedInUserId
        },
        scores: scores
      }})
  };

  submitFile = (formIM) => {
    let form = formIM.toJS();
    const formData = new FormData();
    _.forEach(form.file, file => {
      formData.append('file', file)
    });

    this.props.createScoreRecordFromFile({
      sendBody: formData
    })
  };

  personHasScoredStoreForCriterion = (storeId, criteriaId) => {
    let record;
    _.forEach(this.props.scoreRecords, scoreRecord => {
      record = _.find(scoreRecord.scores, score => {
        return score.storeId === storeId && score.criteriaId === criteriaId && score.scoreValue
      });
      if(record) { return false}
    });
    return record && record.scoreValue
  };

  getStoreScoreForCriterionAverageValue = (storeId, criteriaId) => {
    const scoreRecords = [];
    _.forEach(this.props.scoreRecords, scoreRecord => {
      const record = _.find(scoreRecord.scores, score => {
        return score.storeId === storeId && score.criteriaId === criteriaId && score.scoreValue
      });
      if(record) {
        scoreRecords.push(record);
        return true
      }
    });
    const mean = _.meanBy(scoreRecords, scoreRecord => {return scoreRecord.scoreValue});
    return Number.isNaN(mean)?null:mean;
  };

  resetTableFilters = () => {
    this.props.reset('scoreTypeForm');
    this.props.changeStoresState({
      key: 'stores',
      value: []
    });
    this.props.changeDepartmentsState({
      key: 'departments',
      value: []
    });
  };

  render(){
    const scoreRecord = parseScoreRecord(this.props.criteria, this.props.stores)
    return (
      <ScoreRecord
        {...this.props}
        scoreRecord={
          this.props.displayStoresWithoutScores?
            {
              stores: _.filter(scoreRecord.stores, store => {
                return !_.find(store.criteria, criterion => {
                  return  this.personHasScoredStoreForCriterion(store.id, criterion.id)
                });
              })
            }
            :
            scoreRecord
        }
        submitFile={this.submitFile}
        submitStoreType={this.submitStoreType}
        scoreRecordSubmit={this.scoreRecordSubmit}
        parseStore={parseStore}
        parseCriterionFromFormTable={parseCriterionFromFormTable}
        personHasScoredNewStoreForCriterion={this.personHasScoredStoreForCriterion}
        getStoreScoreForCriterionAverageValue={this.getStoreScoreForCriterionAverageValue}
        fetchStoresSuggestions={this.fetchStoresSuggestions}
        resetTableFilters={this.resetTableFilters}
        fetchCitiesSuggestions={this.fetchCitiesSuggestions}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    loggedInPersonDepartmentId: state.loggedInPerson.get('departmentId'),
    loggedInUserId: state.loggedInPerson.get('id'),
    criteria: state.criteria.get('criteria'),
    stores: state.stores.get('stores'),
    scoreTypeFormValue: selector(state, 'scoreType'),
    displayStoresWithoutScores: selector(state, 'displayStoresWithoutScores'),
    uploadModalOpen: state.scoreRecord.get('uploadModalOpen'),
    personRoles: state.loggedInPerson.get('roles'),
    scoreRecords: state.scoreRecords.get('scoreRecords'),
    postingFileMessage: state.scoreRecord.get('postingFileMessage'),
    loading: state.scoreRecord.get('postingFile') || state.scoreRecord.get('posting'),
    postScoreRecordMessage: state.scoreRecord.get('message'),
    totalStores: state.stores.get('stores').count(),
    storeSuggestions: state.stores.get('suggestions'),
    cities: state.stores.get('cities'),
    citiesSuggestions: state.stores.get('citiesSuggestions'),
    fetchingCriteria: state.criteria.get('fetching'),
    fetchingStores: state.stores.get('fetching')
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getStores: (payload) => {
      dispatch(actions.getStores(payload))
    },
    getCriteria: (payload) => {
      dispatch(actions.getCriteria(payload))
    },
    createScoreRecord: (payload) => {
      dispatch(actions.createScoreRecord(payload))
    },
    getScoreRecordById: (payload) => {
      dispatch(actions.getScoreRecordById(payload))
    },
    createScoreRecordFromFile: (payload) => {
      dispatch(actions.createScoreRecordFromFile(payload))
    },
    openUploadModal: (payload) => {
      dispatch(actions.openUploadModal(payload))
    },
    closeUploadModal: (payload) => {
      dispatch(actions.closeUploadModal(payload))
    },
    getScoreRecords: (payload) => {
      dispatch(actions.getScoreRecords(payload))
    },
    changeScoreRecordState: (payload) => {
      dispatch(actions.changeScoreRecordState(payload))
    },
    getStoresSuggestions: (payload) => {
      dispatch(actions.getStoresSuggestions(payload))
    },
    changeStoresState: (payload) => {
      dispatch(actions.changeStoresState(payload))
    },
    getCities: (payload) => {
      dispatch(actions.getCities(payload))
    },
    reset: (form) => {
      dispatch(reset(form))
    },
    changeDepartmentsState: (payload) => {
      dispatch(actions.changeDepartmentsState(payload))
  }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(ScoreRecordHOC));



// WEBPACK FOOTER //
// ./src/components/scoreRecord/scoreRecordHOC.js